/**
 * iMunobiom+ LP — purchase, limitka, GSAP, research modal, rolling logos.
 *
 * Shopify port of /assets/frontend/js/parts/imunobiom-pdp.js (iprobio.sk, Venalio, 2026-08-30a),
 * DEV-336. Changes against the Venalio file:
 *  - selecting a bundle fills the visible line-item property „Obsah" (packing slip), any other
 *    option disables it so standard packs carry no property;
 *  - the CTA and the sticky bar show the price without a strikethrough (the struck sum is only
 *    shown in the card, labelled „Pri kúpe jednotlivo:" — see the section comment);
 *  - gift end (15. 10. 23:59): if the page was rendered before the end but is viewed after it,
 *    data-gift="on" elements are swapped for their data-gift="off" twins (preview: ?darcek=koniec);
 *  - press-wall fallback logo reuses the clicked logo's <img> (Shopify asset URLs are not a prefix);
 *  - sticky PDP nav glass-on-scroll (from assets/iprobio-pdp.js, which this page does not load);
 *  - the sticky bar copes with an untracked wave (no counter rendered).
 */
(function () {
	var root = document.getElementById('ib-pdp');
	if (!root) {
		return;
	}

	(function () {
		var nav = document.getElementById('ip-pdp-nav');
		if (!nav) {
			return;
		}
		var onScroll = function () { nav.classList.toggle('scrolled', window.scrollY > 40); };
		window.addEventListener('scroll', onScroll, { passive: true });
		onScroll();
	})();

	function variantInput() {
		return document.querySelector('#imunobiom-product-form .dynamic-variant-input')
			|| document.querySelector('.dynamic-variant-input');
	}

	function setObsah(el) {
		var prop = document.getElementById('ibObsah');
		if (!prop) {
			return;
		}
		var obsah = el && el.getAttribute('data-obsah');
		if (obsah) {
			prop.value = obsah;
			prop.disabled = false;
		} else {
			prop.value = '';
			prop.disabled = true;
		}
	}

	window.selectOption = function (el, variantId) {
		if (!el) {
			return;
		}
		root.querySelectorAll('.price-option').forEach(function (o) {
			o.classList.remove('selected');
		});
		el.classList.add('selected');
		if (variantId) {
			var input = variantInput();
			if (input) {
				input.value = variantId;
			}
		}
		setObsah(el);
	};

	/* Gift end: swap gift offers for the plain ones if the page outlived the end date. */
	(function () {
		var end = Number(root.getAttribute('data-gift-end')) * 1000;
		var forced = new URLSearchParams(location.search).get('darcek') === 'koniec';
		if (!forced && !(end && Date.now() > end)) {
			return;
		}
		var on = root.querySelectorAll('[data-gift="on"]');
		if (!on.length) {
			return;
		}
		var selMonths = null;
		on.forEach(function (el) {
			if (el.classList.contains('selected')) {
				selMonths = el.getAttribute('data-months');
			}
			el.remove();
		});
		root.querySelectorAll('[data-gift="off"]').forEach(function (el) {
			el.hidden = false;
		});
		if (selMonths) {
			var twin = root.querySelector('.price-option[data-months="' + selMonths + '"]');
			if (twin) {
				window.selectOption(twin, twin.getAttribute('data-variant-id'));
			}
		}
	})();

	window.toggleFaq = function (el) {
		var isActive = el.classList.contains('active');
		root.querySelectorAll('.faq-item').forEach(function (item) {
			item.classList.remove('active');
		});
		if (!isActive) {
			el.classList.add('active');
		}
	};

	var extraBadges = root.querySelectorAll('.extra-badge');
	extraBadges.forEach(function (b) {
		b.addEventListener('click', function (e) {
			if (e.target.closest('.extra-tip')) {
				return;
			}
			var wasOpen = b.classList.contains('open');
			extraBadges.forEach(function (o) {
				o.classList.remove('open');
			});
			if (!wasOpen) {
				b.classList.add('open');
			}
		});
	});
	document.addEventListener('click', function (e) {
		if (!e.target.closest('.extra-badge')) {
			extraBadges.forEach(function (b) {
				b.classList.remove('open');
			});
		}
	});

	var shipPills = root.querySelectorAll('.trust-item--ship');
	shipPills.forEach(function (p) {
		p.addEventListener('click', function (e) {
			if (e.target.closest('.ship-tip')) {
				return;
			}
			var wasOpen = p.classList.contains('open');
			shipPills.forEach(function (o) {
				o.classList.remove('open');
			});
			if (!wasOpen) {
				p.classList.add('open');
			}
		});
	});
	document.addEventListener('click', function (e) {
		if (!e.target.closest('.trust-item--ship')) {
			shipPills.forEach(function (p) {
				p.classList.remove('open');
			});
		}
	});

	var evidenceStats = root.querySelectorAll('.evidence-stat');
	evidenceStats.forEach(function (s) {
		s.addEventListener('click', function (e) {
			if (e.target.closest('.evidence-tip')) {
				return;
			}
			var wasOpen = s.classList.contains('open');
			evidenceStats.forEach(function (o) {
				o.classList.remove('open');
			});
			if (!wasOpen) {
				s.classList.add('open');
			}
		});
	});
	document.addEventListener('click', function (e) {
		if (!e.target.closest('.evidence-stat')) {
			evidenceStats.forEach(function (s) {
				s.classList.remove('open');
			});
		}
	});

	var heroPills = root.querySelectorAll('.product-stage .pill');
	heroPills.forEach(function (p) {
		p.addEventListener('click', function (e) {
			if (e.target.closest('.pill-tip')) {
				return;
			}
			var wasOpen = p.classList.contains('open');
			heroPills.forEach(function (o) {
				o.classList.remove('open');
			});
			if (!wasOpen) {
				p.classList.add('open');
			}
		});
	});
	document.addEventListener('click', function (e) {
		if (!e.target.closest('.product-stage .pill')) {
			heroPills.forEach(function (p) {
				p.classList.remove('open');
			});
		}
	});

	function runGsapReveal() {
		if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
			return;
		}
		gsap.registerPlugin(ScrollTrigger);
		gsap.from(root.querySelectorAll('.gsap-hero'), { y: 40, opacity: 0, duration: 1, stagger: 0.15, ease: 'power3.out' });
		gsap.from(root.querySelectorAll('.gsap-hero-img'), { x: 40, opacity: 0, duration: 1.2, ease: 'power3.out', delay: 0.3 });
		gsap.utils.toArray(root.querySelectorAll('.gsap-reveal')).forEach(function (elem) {
			ScrollTrigger.create({
				trigger: elem,
				start: 'top 88%',
				once: true,
				onEnter: function () {
					gsap.to(elem, { y: 0, opacity: 1, duration: 0.8, ease: 'power3.out' });
				},
			});
		});
		var doseItems = root.querySelectorAll('.mechanism-section .dose-in');
		if (doseItems.length && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
			gsap.set(doseItems, { opacity: 0, y: 14 });
			ScrollTrigger.create({
				trigger: '.mechanism-section',
				start: 'top 72%',
				once: true,
				onEnter: function () {
					gsap.to(doseItems, { y: 0, opacity: 1, duration: 0.55, stagger: 0.055, ease: 'power3.out' });
				},
			});
		}
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', runGsapReveal);
	} else {
		runGsapReveal();
	}

	window.addEventListener('load', function () {
		if (window.gsap && window.ScrollTrigger) {
			return;
		}
		document.documentElement.classList.remove('js-anim');
		root.querySelectorAll('.gsap-reveal, .dose-in').forEach(function (el) {
			el.style.opacity = '1';
			el.style.transform = 'none';
		});
	});

	(function () {
		var rmm = document.getElementById('ipResearchModal');
		if (!rmm || rmm.dataset.iprWired) {
			return;
		}
		rmm.dataset.iprWired = '1';
		var trigger = null;
		var animated = false;
		function animate() {
			if (animated) {
				return;
			}
			animated = true;
			var scrollRoot = rmm.querySelector('.rm-scroll');
			if (!('IntersectionObserver' in window)) {
				rmm.querySelectorAll('.rm-anim').forEach(function (el) {
					el.classList.add('in');
				});
				return;
			}
			[['.rm-section', 0], ['.rm-thesis__step', 60], ['.rm-method', 55], ['.rm-ladder__step', 55], ['.rm-product', 90], ['.rm-sources li', 26]].forEach(function (g) {
				rmm.querySelectorAll(g[0]).forEach(function (el, n) {
					el.classList.add('rm-anim');
					el.style.setProperty('--d', (n * g[1]) + 'ms');
				});
			});
			var io = new IntersectionObserver(function (es) {
				es.forEach(function (e) {
					if (e.isIntersecting) {
						e.target.classList.add('in');
						io.unobserve(e.target);
					}
				});
			}, { root: scrollRoot, threshold: 0.08, rootMargin: '0px 0px -6% 0px' });
			rmm.querySelectorAll('.rm-anim,.rm-timeline,.rm-era').forEach(function (el) {
				io.observe(el);
			});
			rmm.querySelectorAll('.rm-era').forEach(function (el, n) {
				el.style.setProperty('--d', (n * 90) + 'ms');
			});
			var links = [].slice.call(rmm.querySelectorAll('.rm-nav a'));
			var spy = new IntersectionObserver(function (es) {
				es.forEach(function (e) {
					if (!e.isIntersecting) {
						return;
					}
					links.forEach(function (a) {
						a.classList.toggle('on', a.getAttribute('href') === '#' + e.target.id);
					});
				});
			}, { root: scrollRoot, threshold: 0.02, rootMargin: '-12% 0px -70% 0px' });
			rmm.querySelectorAll('.rm-section[id]').forEach(function (s) {
				spy.observe(s);
			});
		}
		document.querySelectorAll('[data-research-open]').forEach(function (b) {
			b.addEventListener('click', function () {
				trigger = b;
				rmm.showModal();
				animate();
			});
		});
		rmm.querySelectorAll('[data-research-close]').forEach(function (c) {
			c.addEventListener('click', function () {
				rmm.close();
			});
		});
		rmm.addEventListener('click', function (e) {
			if (e.target === rmm) {
				rmm.close();
			}
		});
		rmm.addEventListener('close', function () {
			if (trigger) {
				trigger.focus();
				trigger = null;
			}
		});
	})();

	var rlTrack = document.getElementById('rlTrack');
	if (rlTrack) {
		Array.from(rlTrack.childNodes).forEach(function (node) {
			if (node.nodeType === 3) {
				node.remove();
			}
		});
		var mask = rlTrack.parentElement;
		var mq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false, addEventListener: function () {} };
		var mediaBase = (rlTrack.getAttribute('data-media-base') || '').replace(/\/?$/, '/');
		var mediaV = rlTrack.getAttribute('data-media-v');
		var mediaSuffix = mediaV ? ('?v=' + mediaV) : '';
		var SPEED = 65;
		var mx = 0;
		var period = 0;
		var lastTs = 0;
		var paused = false;
		var rafId = 0;
		var vel = SPEED;
		var dragging = false;
		var justDragged = false;
		function measure() {
			var gap = parseFloat(getComputedStyle(rlTrack).columnGap) || 0;
			period = (rlTrack.scrollWidth + gap) / 2;
		}
		function frame(ts) {
			var dt = lastTs ? Math.min(48, ts - lastTs) : 16;
			lastTs = ts;
			if (!dragging && !paused && period > 10) {
				vel += (SPEED - vel) * Math.min(1, dt / 1000 * 2.5);
				mx += vel * dt / 1000;
				mx = ((mx % period) + period) % period;
			}
			if (period > 10) {
				rlTrack.style.transform = 'translateX(' + (-mx).toFixed(2) + 'px)';
			}
			rafId = requestAnimationFrame(frame);
		}
		function startMarquee() {
			if (mq.matches) {
				if (rafId) {
					cancelAnimationFrame(rafId);
					rafId = 0;
				}
				rlTrack.style.transform = '';
				return;
			}
			measure();
			if (!rafId) {
				lastTs = 0;
				rafId = requestAnimationFrame(frame);
			}
		}
		startMarquee();
		window.addEventListener('load', measure);
		var rzt;
		window.addEventListener('resize', function () {
			clearTimeout(rzt);
			rzt = setTimeout(measure, 200);
		}, { passive: true });
		if (!window.matchMedia || window.matchMedia('(hover: hover)').matches) {
			mask.addEventListener('mouseover', function () { paused = true; });
			mask.addEventListener('mouseout', function (e) {
				var rel = e.relatedTarget;
				if (!rel || !mask.contains(rel)) {
					paused = false;
				}
			});
		}

		var ov = document.getElementById('rlOverlay');
		var md = document.getElementById('rlModal');
		var fr = document.getElementById('rlFrame');
		var ti = document.getElementById('rlTitle');
		var ob = document.getElementById('rlOpen');
		var fbtn = document.getElementById('rlFull');
		var ftx = document.getElementById('rlFullTxt');
		var cb = document.getElementById('rlClose');
		var fb = document.getElementById('rlFallback');
		var fbN = document.getElementById('rlFbName');
		var fbL = document.getElementById('rlFbLogo');
		var fbO = document.getElementById('rlFbOpen');
		var last = null;
		var fullLabel = ftx ? ftx.textContent : 'Celá obrazovka';
		var shrinkLabel = fbtn ? fbtn.getAttribute('data-shrink-label') || 'Zmenšiť' : 'Zmenšiť';
		var scrollY = 0;
		function lockScroll() {
			scrollY = window.scrollY || window.pageYOffset || 0;
			var b = document.body.style;
			b.position = 'fixed';
			b.top = (-scrollY) + 'px';
			b.left = '0';
			b.right = '0';
			b.width = '100%';
		}
		function unlockScroll() {
			var b = document.body.style;
			b.position = '';
			b.top = '';
			b.left = '';
			b.right = '';
			b.width = '';
			window.scrollTo(0, scrollY);
		}
		function openModal(item, triggerEl) {
			last = triggerEl || null;
			if (ti) {
				ti.textContent = item.a;
			}
			if (ob) {
				ob.href = item.u;
			}
			if (fbO) {
				fbO.href = item.u;
			}
			if (item.e) {
				if (fb) {
					fb.classList.remove('show');
				}
				if (fr) {
					fr.style.display = 'block';
					fr.src = item.u;
				}
			} else if (fr && fb && fbN && fbL) {
				fr.style.display = 'none';
				fr.removeAttribute('src');
				fbN.textContent = item.a;
				fbL.src = item.img || (mediaBase + item.f + mediaSuffix);
				fbL.alt = item.a;
				fb.classList.add('show');
			}
			if (ov) {
				ov.classList.add('open');
			}
			lockScroll();
			(item.e ? cb : fbO).focus();
			document.addEventListener('keydown', onKey);
		}
		function closeModal() {
			if (ov) {
				ov.classList.remove('open');
			}
			if (md) {
				md.classList.remove('is-full');
			}
			if (fbtn) {
				fbtn.setAttribute('aria-pressed', 'false');
			}
			if (ftx) {
				ftx.textContent = fullLabel;
			}
			if (fr) {
				fr.removeAttribute('src');
			}
			if (fb) {
				fb.classList.remove('show');
			}
			unlockScroll();
			document.removeEventListener('keydown', onKey);
			if (last && last.focus) {
				last.focus();
				paused = false;
			}
		}
		function onKey(e) {
			if (e.key === 'Escape') {
				closeModal();
			}
		}
		rlTrack.addEventListener('click', function (e) {
			var link = e.target.closest && e.target.closest('.rl-logo');
			if (!link) {
				return;
			}
			e.preventDefault();
			if (justDragged) {
				return;
			}
			openModal({
				a: link.getAttribute('data-outlet'),
				u: link.href,
				e: link.getAttribute('data-embed') === '1',
				f: link.getAttribute('data-file'),
				img: link.querySelector('img') ? link.querySelector('img').src : '',
			}, link);
		});
		if (fbtn && md && ftx) {
			fbtn.addEventListener('click', function () {
				var on = md.classList.toggle('is-full');
				fbtn.setAttribute('aria-pressed', on ? 'true' : 'false');
				ftx.textContent = on ? shrinkLabel : fullLabel;
			});
		}
		if (cb) {
			cb.addEventListener('click', closeModal);
		}
		if (ov) {
			ov.addEventListener('click', function (e) {
				if (e.target === ov) {
					closeModal();
				}
			});
		}
	}

	/* LIMITKA behavior — CTA sync, sold-out, sticky widget, duo modal */
	(function () {
		var form = document.getElementById('imunobiom-product-form');
		var cta = document.getElementById('heroCta');
		if (!form || !cta) {
			return;
		}

		function sync() {
			var sel = root.querySelector('.price-option.selected');
			var lim = sel && sel.classList.contains('lim-option');
			if (!sel) {
				return;
			}
			var verb = lim
				? (root.getAttribute('data-cta-reserve') || 'Rezervovat balíček')
				: (root.getAttribute('data-cta-add') || 'Přidat do košíku');
			var payEl = sel.querySelector('.option-price');
			var pay = payEl ? payEl.textContent.trim() : '';
			var saveText = (sel.getAttribute('data-save-text') || '').trim();
			var saveV = sel.getAttribute('data-save');
			var hasSave = !!saveText && saveV !== '0';
			cta.innerHTML = '<span class="cta-main">' +
				'<span class="cta-verb">' + verb + '</span><span class="cta-dot">·</span>' +
				'<span class="cta-price">' + pay + '</span>' +
				'</span>' +
				'';  // savings are shown in the pack selector above, not on the button (Stefan 2026-11-01)
		}

		window.selectLimitka = function (el) {
			if (!el || el.classList.contains('lim-locked') || el.classList.contains('lim-hidden') || el.classList.contains('lim-soldout')) {
				return;
			}
			window.selectOption(el, el.getAttribute('data-variant-id'));
			pointStickyAt(el);
			sync();
		};

		var preselected = root.querySelector('.price-option.selected');
		if (preselected) {
			setObsah(preselected);
		}

		root.addEventListener('click', function (e) {
			if (e.target.closest && e.target.closest('.price-option')) {
				setTimeout(sync, 0);
			}
		});

		function stockLeftLabel() {
			return (root.getAttribute('data-stock-left') || 'Zbývá');
		}
		function stockOfLabel() {
			return (root.getAttribute('data-stock-of') || 'z');
		}
		function soldoutBadgeLabel() {
			return (root.getAttribute('data-soldout-badge') || 'Vyprodáno');
		}
		function soldoutNoteLabel(n) {
			return (root.getAttribute('data-soldout-note') || 'Všech {0} balíčků je vyprodaných').replace('{0}', n);
		}

		function activeLimOption() {
			return root.querySelector('.lim-option.selected:not(.lim-locked):not(.lim-hidden):not(.lim-soldout)')
				|| root.querySelector('.lim-option:not(.lim-locked):not(.lim-hidden):not(.lim-soldout)');
		}

		function formatBarPrice(val) {
			var n = Number(val);
			if (!isFinite(n)) {
				return String(val || '');
			}
			return new Intl.NumberFormat('cs-CZ', { style: 'currency', currency: 'CZK', minimumFractionDigits: n % 1 === 0 ? 0 : 2, maximumFractionDigits: 2 }).format(n);
		}

		function pointStickyAt(card) {
			var bar = document.getElementById('limBar');
			if (!bar || !card) {
				return;
			}
			var pkg = card.getAttribute('data-package') === 'wave2' ? 'w2' : 'w1';
			var t = bar.querySelector('.lb-title');
			if (t) {
				t.textContent = bar.getAttribute('data-' + pkg + '-title') || t.textContent;
			}
			var d = bar.querySelector('.lb-sub');
			if (d) {
				d.textContent = bar.getAttribute('data-' + pkg + '-sub') || d.textContent;
			}
			var payEl = card.querySelector('.option-price');
			var pb = bar.querySelector('.lb-price b');
			if (pb) {
				pb.textContent = payEl ? payEl.textContent.trim() : formatBarPrice(card.getAttribute('data-pay'));
			}
			var st = card.querySelector('.lim-stock');
			var lbStock = document.getElementById('lbStock');
			if (!st && lbStock) {
				lbStock.textContent = '';
				var m0 = bar.querySelector('.lb-meter');
				if (m0) {
					m0.hidden = true;
				}
			}
			if (st && lbStock) {
				var left = st.getAttribute('data-stock');
				var total = st.getAttribute('data-stock-total');
				lbStock.textContent = stockLeftLabel() + ' ' + left + ' ' + stockOfLabel() + ' ' + total;
				var meter = bar.querySelector('.lb-meter i');
				var tNum = Number(total);
				var lNum = Number(left);
				if (meter && tNum > 0) {
					meter.style.width = Math.max(0, Math.min(100, Math.round((lNum / tNum) * 100))) + '%';
				}
			}
		}

		function removeSticky() {
			var lb = document.getElementById('limBar');
			if (lb) {
				lb.remove();
			}
		}

		function unlockWave2(w2) {
			if (!w2 || w2.classList.contains('lim-soldout')) {
				return;
			}
			w2.classList.remove('lim-locked', 'lim-hidden');
			w2.removeAttribute('aria-disabled');
			w2.removeAttribute('hidden');
			var lock = w2.querySelector('.lim-lock');
			if (lock) {
				lock.remove();
			}
			var stock = w2.querySelector('.lim-stock');
			if (stock) {
				stock.hidden = false;
			}
		}

		var bar = document.getElementById('limBar');
		if (bar) {
			pointStickyAt(activeLimOption());
			var purchase = document.getElementById('hero-purchase');
			var pageFoot = document.querySelector('footer.footer') || document.querySelector('footer.ipf');
			var barSync = function () {
				var hide = false;
				if (purchase) {
					var r = purchase.getBoundingClientRect();
					if (r.bottom > 0 && r.top < window.innerHeight * 0.9) {
						hide = true;
					}
				}
				if (!hide && pageFoot) {
					var fr = pageFoot.getBoundingClientRect();
					if (fr.height > 0 && fr.top < window.innerHeight) {
						hide = true;
					}
				}
				bar.classList.toggle('hide', hide);
			};
			barSync();
			window.addEventListener('scroll', barSync, { passive: true });
			window.addEventListener('resize', barSync, { passive: true });
			var lbCta = document.getElementById('lbCta');
			if (lbCta) {
				lbCta.addEventListener('click', function () {
					var active = activeLimOption();
					if (active && !active.classList.contains('selected')) {
						window.selectLimitka(active);
					}
					if (form.requestSubmit) {
						form.requestSubmit(cta);
					} else {
						cta.click();
					}
				});
			}
		}

		var duoModal = document.getElementById('duoModal');
		var limWhy = document.getElementById('limWhy');
		if (duoModal && limWhy) {
			limWhy.addEventListener('click', function () {
				duoModal.showModal();
			});
			duoModal.addEventListener('click', function (e) {
				if (e.target.closest('[data-duo-close]')) {
					duoModal.close();
					return;
				}
				var r = duoModal.getBoundingClientRect();
				if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) {
					duoModal.close();
				}
			});
			var duoCta = duoModal.querySelector('.duo-cta');
			if (duoCta) {
				duoCta.addEventListener('click', function () {
					duoModal.close();
				});
			}
		}

		function limSetSoldOut(which) {
			var card = root.querySelector('.price-option[data-package="' + (which === 'w1' ? 'wave1' : 'wave2') + '"]');
			if (!card) {
				return;
			}
			var stockEl = card.querySelector('.lim-stock');
			var n = (stockEl && stockEl.getAttribute('data-stock-total')) || (which === 'w1' ? '50' : '100');
			if (!card.classList.contains('lim-soldout')) {
				card.classList.remove('selected');
				card.classList.add('lim-soldout');
				var stb = card.querySelector('.lim-stock b');
				if (stb) {
					stb.textContent = '0 ' + stockOfLabel() + ' ' + n;
				}
				var mi = card.querySelector('.lim-stock .lim-meter i, .lim-meter i');
				if (mi) {
					mi.style.width = '0%';
				}
				card.insertAdjacentHTML('beforeend',
					'<div class="lim-soldout__veil" aria-hidden="true"></div>' +
					'<div class="lim-soldout__msg" role="status"><span class="lso-badge">' + soldoutBadgeLabel() + '</span><span class="lso-note">' + soldoutNoteLabel(n) + '</span></div>');
			}
			if (which === 'w1') {
				var w2 = root.querySelector('.price-option[data-package="wave2"]');
				unlockWave2(w2);
				if (w2 && !w2.classList.contains('lim-soldout')) {
					window.selectLimitka(w2);
					pointStickyAt(w2);
				} else {
					removeSticky();
				}
			} else if (root.querySelector('.price-option[data-package="wave1"].lim-soldout')) {
				var m6 = root.querySelector('.price-option[data-months="6"]');
				if (m6 && typeof window.selectOption === 'function') {
					window.selectOption(m6, m6.getAttribute('data-variant-id'));
				}
				removeSticky();
			}
			sync();
		}

		window.limSetSoldOut = limSetSoldOut;
		var so = new URLSearchParams(location.search).get('soldout') || root.getAttribute('data-soldout');
		if (so === 'w1' || so === 'all') {
			limSetSoldOut('w1');
		}
		if (so === 'w2' || so === 'all') {
			limSetSoldOut('w2');
		}
		sync();
	})();
})();

/* Bottom-CTA pack pills: real buttons synced with the hero selector (Stefan 2026-10-13, all PDPs).
   Gift twins share a variant id; the click picks the visible twin. A wave (limitka) selection clears the pills. */
(function () {
	var root = document.getElementById('ib-pdp') || document;
	function visible(el) { return el && !el.hidden && !el.hasAttribute('hidden') && !el.classList.contains('lim-hidden'); }
	function sync() {
		var sel = root.querySelector('.price-option.selected');
		var vid = sel ? String(sel.getAttribute('data-variant-id') || '') : '';
		root.querySelectorAll('.cta-price-pill[data-variant-id]').forEach(function (p) {
			var on = !!vid && p.getAttribute('data-variant-id') === vid;
			p.classList.toggle('active', on);
			p.setAttribute('aria-pressed', on ? 'true' : 'false');
		});
	}
	root.addEventListener('click', function (e) {
		var p = e.target.closest && e.target.closest('.cta-price-pill[data-variant-id]');
		if (p) {
			var vid = p.getAttribute('data-variant-id');
			var opts = Array.prototype.slice.call(root.querySelectorAll('.price-option[data-variant-id="' + vid + '"]'));
			var opt = opts.filter(visible)[0] || opts[0];
			if (opt && typeof window.selectOption === 'function') { window.selectOption(opt, vid); }
			sync();
			return;
		}
		if (e.target.closest && e.target.closest('.price-option')) { setTimeout(sync, 0); }
	});
	sync();
})();
